import type { PageEventHandler } from '@/play/pageTypes'

/*
 * Reducer handlers of every page with durable events of its own (`experience.<id>.<verb>`), found
 * by folder: a page's `<nnn>-<slug>/events.ts` exports them as `eventHandlers`. Only the pages'
 * events modules are imported here (no UI), so the reducer stays light. Folders starting with `_`
 * are not pages.
 */
const modules = import.meta.glob<{ eventHandlers?: Record<string, PageEventHandler> }>(
  ['./*/events.ts', '!./_*/events.ts'],
  { eager: true },
)

/** Handlers per page folder, for checks (src/pages/catalog.test.ts). */
export const PAGE_EVENT_HANDLERS_BY_FOLDER: Readonly<Record<string, Record<string, PageEventHandler>>> = Object.fromEntries(
  Object.entries(modules)
    .filter(([, mod]) => mod.eventHandlers)
    .map(([path, mod]) => [path.split('/')[1], mod.eventHandlers!]),
)

export const pageEventHandlers: Record<string, PageEventHandler> = Object.assign({}, ...Object.values(PAGE_EVENT_HANDLERS_BY_FOLDER))
